import { useQuery } from '@tanstack/react-query'
import { groupsService } from './groupsService'

export const GROUPS_KEYS = {
  groups: (buildingUuid: string) => ['groups', buildingUuid] as const,
  userGroups: ['groups', 'user'] as const,
}

export const useGetGroupsQuery = (buildingUuid: string) => {
  return useQuery({
    queryKey: GROUPS_KEYS.groups(buildingUuid),
    queryFn: () => groupsService.getGroups(buildingUuid),
    enabled: !!buildingUuid,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  })
}

export const useGetGroupsOfUserQuery = () => {
  return useQuery({
    queryKey: GROUPS_KEYS.userGroups,
    queryFn: () => groupsService.getGroupsOfUser(),
    staleTime: 0,
  })
}


